<template>
  <div class="max-w-screen-lg xl:max-w-screen-xl mx-auto mt-10 xl:mt-8">
    <div class="px-4 sm:px-6 md:px-8 mb-14 sm:mb-20 xl:mb-8">
      <div
        class="font-montserrat text-2xl md:text-3xl lg:text-4xl font-semibold text-red-700 mb-2"
      >
        See Custom Analytics Tool..
      </div>
      <p
        class="max-w-4xl text-lg sm:text-xl font-montserrat text-gray-400 sm:leading-8 space-y-6 mb-6"
      >
        Check a custom analytics tool for projects on Ethereum Network,<br />,the featured Dashboard is for Enzyme Finance 
      </p>
      <ul class="flex space-x-6 font-montserrat text-gray-600">
        <li class="flex flex-col items-center space-y-1">
          <div
            class="relative bg-gradient-to-tr from-red-400 to-red-700 p-1 rounded-full"
          >
            <div
              class="block bg-white p-1 rounded-full transform transition hover:-rotate-6"
            >
              <img
                class="h-24 w-24 rounded-full"
                src="enzyme.jpeg"
                alt="you"
              />
            </div>
            <button
              class="absolute bottom-0 right-1 bg-red-500 h-8 w-8 rounded-full text-white text-2xl font-semibold border-4 border-white flex justify-center items-center font-mono hover:bg-red-700"
            >
               <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
                width="24"
                class="fill-current"
              >
                <path d="M0 0h24v24H0V0z" fill="none" />
                <path
                  d="M18 13h-5v5c0 .55-.45 1-1 1s-1-.45-1-1v-5H6c-.55 0-1-.45-1-1s.45-1 1-1h5V6c0-.55.45-1 1-1s1 .45 1 1v5h5c.55 0 1 .45 1 1s-.45 1-1 1z"
                />
              </svg>
            </button>
          </div>
          <div class="text-gray-600">You</div>
        </li>
      </ul>
    </div>
    <div class="max-w-screen-lg xl:max-w-screen-xl flex">
      <div
        class="px-4 sm:px-6 md:px-8 mb-14 sm:mb-20 xl:mb-8 mt-4 lg:mt-2 xl:mt-6"
      >
        <a
          class="shadow-lg font-montserrat w-full sm:w-auto flex-none bg-gradient-to-r from-red-500 to-red-400 hover:from-red-600 hover:to-red-500 text-white font-semibold leading-6 py-3 px-6 border border-transparent rounded-lg focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-red-900 focus:outline-none inline-flex items-baseline"
          href="https://duneanalytics.com/JMosi/ENZYME-DASHBOARD"
          target="_blank"
          rel="noopener"
        >
          Go to Enzyme tool
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="18px"
            viewBox="0 0 24 24"
            width="18px"
            fill="white"
            class="h-6 w-6 fill-current place-self-end ml-1"
          >
            <path d="M0 0h24v24H0z" fill="none" />
            <path
              d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z"
            />
          </svg>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LandingShares",
};
</script>
